(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("ConfigController", ConfigController);

    ConfigController.$inject = [
        "$state",
        "$scope",
        "$stateParams",
        "ConfigList",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "ConfigSearch"
    ];

    function ConfigController(
        $state,
        $scope,
        $stateParams,
        ConfigList,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        ConfigSearch
    ) {
        var vm = this;
        vm.page = pagingParams.page;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterConfigSearch = filterConfigSearch;
        
        loadAll();

        function loadAll() {

            ConfigList.query({
                page: vm.page-1,
                size: vm.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }, function (data, headers) {
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.configs = data;
                vm.page = pagingParams.page;

            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                size: vm.itemsPerPage,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch
            });
        }

        function filterConfigSearch() {
            if ($scope.search) {
                ConfigSearch.query({
                    searchText: $scope.search,
                    page: vm.page-1,
                    size: vm.itemsPerPage,
                    sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
                }, function (data, headers) {
                    vm.totalItems = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.configs = data;
                    vm.page = pagingParams.page;

                });
            } else {
                loadAll();
            }
        }
    }
})();
